// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deprecated-root[data-v-6321a175] {\n  width: 100%;\n  height: 100vh;\n  background: #ffffff;\n}\n.deprecated-root .main[data-v-6321a175] {\n  width: 100%;\n}\n.deprecated-root .main p[data-v-6321a175] {\n  width: 80%;\n  margin: 30vh auto 0;\n  text-align: center;\n  font-size: 16px;\n  color: #333333;\n}", ""]);
// Exports
module.exports = exports;
